import { helpers } from 'vuelidate/lib/validators';

export const containsAlpha = helpers.regex('alpha', /^.*[a-zA-Z]+.*$/);
export const containsNumeric = helpers.regex('numeric', /^.*[0-9]+.*$/);
export const containsUppercase = helpers.regex('uppercase', /^.*[A-Z]+.*$/);
